var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron relative"},[_c('hotspot-richmedia',{staticClass:"bottom-2 left-2 lg:left-36",attrs:{"options":{
                    icon: 'diaporama',
                    collection: _vm.getRichmediaByCollection(
                        _vm.currentPage,
                        'Dossier de presse : Kembs, un projet environnemental d’exception'
                    ),
                }}}),_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.image1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.image1.alt,
                        position: 'bottom-left', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    },
                    {
                        text: _vm.currentPage.images.image1.text,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-selective_orange',
                    to: 'to-selective_yellow',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.chapterTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.chapterDescription.text)}}),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card",staticStyle:{"margin-bottom":"0px"}},[_c('TitleParagraph',{staticClass:"mb-4",attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('span',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstTitle.text)}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstParagraph.text)}})])],1),_c('div',{staticClass:"block md:hidden"},[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image4.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image4.text,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                    fontSize: 'text-xs md:text-base',
                                } ],
                        }}})],1),_c('div',{staticClass:"card"},[_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.secondParagraph.text
                            )}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{staticClass:"mb-4",attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('span',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondTitle.text)}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdParagraph.text)}})])],1)]),_c('div',{staticClass:"w-full md:w-3/4 mx-auto md:mt-10"},[_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.image2.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.image2.text,
                                color: 'text-tundora',
                                fontSize:
                                    'text-xs lg:m-0 text-xs lg:text-base xl:text-lg',
                                position: 'top-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.image2.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }